var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureStreamlineIconHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-hierarchy-9_64x64",
    "data-name": "streamline-icon-hierarchy-9@64x64",
    transform: "translate(0 0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M26,27.995a10,10,0,1,0,10-10,10,10,0,0,0-10,10Z",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M50,7.995a6,6,0,1,0,6-6,6,6,0,0,0-6,6Z",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M50,41.995a6,6,0,1,0,6-6A6,6,0,0,0,50,41.995Z",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M30,55.995a6,6,0,1,0,6-6A6,6,0,0,0,30,55.995Z",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M2,55.995a6,6,0,1,0,6-6,6,6,0,0,0-6,6Z",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M4,13.995a6,6,0,1,0,6-6,6,6,0,0,0-6,6Z",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M43.069,20.928l8.693-8.693",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M44.784,32.779l6.093,6.093",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M36,37.995v12",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M28.936,35.059l-16.7,16.7",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M26.669,24.4,14.96,17.371",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureStreamlineIconHierarchy);
export default __webpack_public_path__ + "static/media/feature-streamline-icon-hierarchy.c95ac00c.svg";
export { ForwardRef as ReactComponent };